import type { ReactNode } from "react";
import Header from "@/components/feature/Header";
import Footer from "@/components/feature/Footer";
import ScrollTopButton from "@/components/base/ScrollTopButton";
import ScrollToTop from "@/components/base/ScrollToTop";

export default function Layout({ children }: { children: ReactNode }) {
  return (
    <>
      <ScrollToTop />
      <Header />
      <main className="min-h-[70vh] pt-16">{children}</main>
      <Footer />
      <ScrollTopButton />
    </>
  );
}